export default "__VITE_ASSET__EUIUphEX__"